
import { Component, Vue } from 'vue-property-decorator';
import JoeyLoading from './components/shared/JoeyLoading.vue';
import Router from './router';
import { performance } from './shared/services/PerformanceService';

@Component({
    components: {
        JoeyLoading
    }
})
export default class App extends Vue {
    private created() {
        // Fix vue-router issue in IE: https://github.com/vuejs/vue-router/issues/1849
        // Bug: https://aewiki.atlassian.net/browse/AET-2031

        if (this.isIE()) {
            window.addEventListener(
                'hashchange',
                () => {
                    const currentPath = window.location.hash.slice(1);
                    if (this.$route.path !== currentPath) {
                        this.$router.push(currentPath);
                    }
                },
                false
            );
        }
    }

    private get isAppLoaded() {
        return this.$store.state.appLoaded;
    }

    private isIE() {
        const userAgent = navigator.userAgent;
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        return userAgent.indexOf('MSIE ') > -1 || userAgent.indexOf('Trident/') > -1;
    }
}
